import { PERF_ROWS } from "@/data/misc";
import { useWindows } from "@/os/window/context";

export function PerformancePanel() {
    const { open } = useWindows();
    return (
        <div data-testid="performance-panel">
            <p className="font-mono text-[11px] text-inkfaint">profiler output — subject: you. confidence: high. affection: higher.</p>
            <div className="mt-3 overflow-hidden rounded-xl border border-sand">
                <table className="w-full font-mono text-[11.5px]">
                    <thead className="bg-coralsoft text-coral">
                        <tr>
                            <th className="px-2 py-1.5 text-left">process</th>
                            <th className="px-2 py-1.5 text-right">usage</th>
                            <th className="px-2 py-1.5 text-left">note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {PERF_ROWS.map((r) => (
                            <tr key={r.name} className="border-t border-sand">
                                <td className="px-2 py-1.5">{r.name}</td>
                                <td className="px-2 py-1.5 text-right">{r.usage}</td>
                                <td className="px-2 py-1.5 text-inkfaint">{r.note}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <p className="mt-3 rounded-xl border-2 border-coral bg-coralsoft/60 p-3 text-[12.5px] leading-relaxed">
                verdict: the bottleneck is you (affectionate). overthinking is rerendering at 61 decisions/second while the
                application itself waits patiently.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
                <button data-testid="performance-investigate" className="btn btn-coral btn-sm" onClick={() => open("bugs_i_fixed")}>
                    Investigate the real optimization story
                </button>
                <button data-testid="performance-recalibrate" className="btn btn-sm" onClick={() => open("personality")}>
                    recalibrate tolerance
                </button>
            </div>
        </div>
    );
}
